export enum ClientSurveyStatus {
  Scheduled = 'scheduled',
  PendingConfirmation = 'pending_confirmation',
  Confirmed = 'confirmed',
  Overdue = 'overdue',
  Sending = 'sending',
  Sent = 'sent',
  Finished = 'finished',
}
